import { render, staticRenderFns } from "./BoxShadow.vue?vue&type=template&id=f23eb530&scoped=true"
var script = {}
import style0 from "./BoxShadow.vue?vue&type=style&index=0&id=f23eb530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23eb530",
  null
  
)

export default component.exports